module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.iconClassName
  }, [(!_vm.loadingPermission) ? _c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "img-src": _vm.iconSrc,
      "size": _vm.iconSize
    }
  }) : (_vm.iconSrcNew) ? _c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "img-src": _vm.iconSrcNew,
      "size": _vm.iconSize
    }
  }) : _c('rt-icon', {
    attrs: {
      "name": _vm.defaultName,
      "size": _vm.iconSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36210b6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtHeaderIcon.vue
// module id = 2113
// module chunks = 137